import axios from "axios";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_BaseServerURL,
  REACT_APP_BaseServerURL_SANDBOX,
  REACT_APP_baseURL,
  REACT_APP_baseURL_SANDBOX,
} from "utils/constants";
export async function APIHandlerV1({
  method,
  url,
  data,
  isHistoryURL,
  isAbsoluteUrl,
}: any) {
  const baserServerUrl =
    getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? REACT_APP_BaseServerURL
      : REACT_APP_BaseServerURL_SANDBOX;
  const appBaseUrl =
    getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? REACT_APP_baseURL
      : REACT_APP_baseURL_SANDBOX;

  const combineURL = (url: any, isHistoryURL: any) => {
    const baseUrl = isHistoryURL ? baserServerUrl : appBaseUrl;
    return baseUrl + url;
  };

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const request = {
    url: isAbsoluteUrl ? url : combineURL(url, isHistoryURL),
    method,
    headers: {
      appVersion: "1.3.2",
      deviceType: "web",
      withCredentials: true,
      "Content-Type": "application/json",
    },
    data,
    withCredentials: isAbsoluteUrl ? false : true,
    timeout: 100000,
  };
  try {
    return await axios.request(request);
  } catch (error) {
    console.error({ error });
    return Promise.reject(error);
  }
}
